export default __webpack_public_path__ + "b720c0e455366302646fd3fc9c68847a.png";